import { apiClient } from '@/modules/shared/services/apiClient';
import type { ApiResponse, ProgramFormDto } from '@/modules/shared/types';
import type {
  CallLogConfigurationDto,
  CallLogResolvedFormDto,
  SaveCallLogConfigurationDto,
} from '../types/callLogConfig';
import { CALL_LOG_FORM_TYPE } from '../types/callLogConfig';

const CONFIG_BASE = (programId: string) =>
  `/programs/${programId}/call-log-configuration`;

export const callLogConfigService = {
  // ─── Config CRUD ──────────────────────────────────

  async getConfiguration(
    programId: string
  ): Promise<ApiResponse<CallLogConfigurationDto>> {
    const res = await apiClient.get<ApiResponse<CallLogConfigurationDto>>(
      CONFIG_BASE(programId)
    );
    return res.data;
  },

  async saveConfiguration(
    programId: string,
    dto: SaveCallLogConfigurationDto
  ): Promise<ApiResponse<CallLogConfigurationDto>> {
    const res = await apiClient.put<ApiResponse<CallLogConfigurationDto>>(
      CONFIG_BASE(programId),
      dto
    );
    return res.data;
  },

  // ─── Resolved canonical CALL_LOG_FORM ─────────────

  async getResolvedForm(
    programId: string
  ): Promise<ApiResponse<CallLogResolvedFormDto>> {
    const res = await apiClient.get<ApiResponse<CallLogResolvedFormDto>>(
      `${CONFIG_BASE(programId)}/form`
    );
    return res.data;
  },

  // ─── Available forms to pick from (FormType = CALL_LOG_FORM & PUBLISHED) ──

  async getAvailableCallLogForms(
    programId: string
  ): Promise<ApiResponse<{ forms: ProgramFormDto[]; totalCount: number }>> {
    const res = await apiClient.get<
      ApiResponse<{ forms: ProgramFormDto[]; totalCount: number }>
    >(`/programs/${programId}/forms`, {
      params: { status: 'PUBLISHED', pageSize: 200 },
    });

    // Filter client-side to CALL_LOG_FORM type forms
    if (res.data?.success && res.data.data?.forms) {
      res.data.data.forms = res.data.data.forms.filter(
        (f) => f.formType === CALL_LOG_FORM_TYPE
      );
    }

    return res.data;
  },
};
